<template>
    <div>
        <div class="mb-3">
            <div :style="excuteLayoutPrize">
                <div
                    v-for="(itemPrize, idx) in displayedPrizes"
                    :key="idx"
                    class="prize-card"
                    :class="{
                        selected: formInit.serial_prize === itemPrize.make_id,
                        'is-invalid': formConfig.serial_prize.error,
                        'cursor-pointer': defineShowTypeBlock,
                        'pointer-events-none': !defineShowTypeBlock
                    }"
                    @click="defineShowTypeBlock && (formInit.serial_prize = itemPrize.make_id)"
                >
                    <div class="d-flex flex-column justify-content-center align-items-center w-100 h-100 p-4">
                        <div class="title_prize text-center mb-3" :class="{ 'selected-title': formInit.serial_prize === itemPrize.make_id }">
                            {{ itemPrize.title }}
                        </div>
                        <div v-if="itemPrize.image?.path" class="text-center image-container">
                            <img :src="itemPrize.image?.path" :alt="itemPrize.image.origin_name" :style="onHandleStyleImage(itemPrize)" />
                        </div>
                        <div v-if="defineShowTypeBlock" class="mt-3 text-center">
                            <InputRadio
                                :model.sync="formInit.serial_prize"
                                :name="`PrizeSerial`"
                                :id="`PrizeSerial-${itemPrize.make_id}`"
                                :value="itemPrize.make_id"
                                :label="``"
                                :config.sync="formConfig.serial_prize"
                                class="custom-radio-large"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="defineShowTypeBlock && formConfig.serial_prize.error" :class="`form__alert--error text-${choicePlacement('answer')}`">
                {{ formConfig.serial_prize.errorField }}
            </div>
        </div>
    </div>
</template>

<script>
import { InputRadio } from '@/components/Input';
import { onHandleGetValueTextAlign } from '@/views/pages/phase2/manager-form/iframe-page/handlers';
import { PAGE_TYPES } from '@/views/pages/phase2/manager-form/constants';

export default {
    name: 'FormBPrizeCode',
    components: {
        InputRadio
    },
    props: {
        inforData: {
            type: Object,
            default: null
        },
        settingDesign: {
            type: Object,
            default: null
        },
        formInit: {
            type: Object,
            default: null
        },
        formConfig: {
            type: Object,
            default: null
        },
        conditionPageShow: {
            type: String,
            default: ''
        }
    },
    data() {
        return {};
    },

    computed: {
        defineShowTypeBlock() {
            return [PAGE_TYPES._B[0]].includes(this.conditionPageShow);
        },
        displayedPrizes() {
            if (!this.inforData?.serial_code_prizes) return [];
            if (this.defineShowTypeBlock) return this.inforData.serial_code_prizes;
            return this.inforData.serial_code_prizes.filter((p) => p.make_id === this.formInit.serial_prize);
        },
        excuteLayoutPrize() {
            const objLayout = this.inforData?.form_pages?.page_input_serial_code?.setting_layout_prize_serial;
            const valueDirection = objLayout?.direction ? objLayout?.direction?.value || objLayout?.direction : 'horizontal';
            const valueArrangement = objLayout?.arrangement ? objLayout?.arrangement?.value || objLayout?.arrangement : 'center';
            const alignmentStr = valueArrangement === 'left' ? 'flex-start' : valueArrangement === 'right' ? 'flex-end' : 'center';
            if (valueDirection === 'horizontal') {
                return `display: flex; flex-wrap: wrap; gap: 24px; justify-content: ${alignmentStr};`;
            } else {
                return `display: flex; flex-direction: column; gap: 24px; align-items: ${alignmentStr};`;
            }
        }
    },
    methods: {
        choicePlacement(type) {
            switch (type) {
                case 'question':
                    return onHandleGetValueTextAlign(this.settingDesign.table_settings.question_text_alignment.horizontal);
                case 'answer':
                    return onHandleGetValueTextAlign(this.settingDesign.table_settings.answer_text_alignment.horizontal);
            }
        },

        onHandleStyleImage(itemPrize) {
            const style = {};
            style.width = `${itemPrize?.width_image || 250}px`;
            if (itemPrize?.height_image) {
                style.height = `${itemPrize?.height_image}px`;
            }
            return style;
        }
    }
};
</script>

<style lang="scss" scoped>
.cursor-pointer {
    cursor: pointer;
}
.title_prize {
    transition: color 0.3s ease;
    &.selected-title {
        color: #4aa3ff;
        font-weight: bold;
    }
}
.prize-card {
    border: 2px solid transparent;
    border-radius: 12px;
    background-color: #ffffff;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    position: relative;
    overflow: hidden;
    max-width: 100%;

    &:hover {
        transform: translateY(-4px);
        box-shadow: 0 10px 20px rgba(0, 0, 0, 0.05);

        .image-container img {
            transform: scale(1.03);
        }
    }

    &.selected {
        border-color: #4aa3ff;
        background-color: rgba(74, 163, 255, 0.04);
        box-shadow:
            0 0 0 4px rgba(74, 163, 255, 0.15),
            0 8px 16px rgba(74, 163, 255, 0.1);

        &::after {
            content: '';
            position: absolute;
            top: 6px;
            right: 6px;
            width: 18px;
            height: 18px;
            background-color: #4aa3ff;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='white' width='16px' height='16px'%3E%3Cpath d='M0 0h24v24H0V0z' fill='none'/%3E%3Cpath d='M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z'/%3E%3C/svg%3E");
            background-repeat: no-repeat;
            background-position: center;
            animation: popIn 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
        }
    }

    &.is-invalid {
        border-color: #dc3545;
        &:hover {
            border-color: #bd2130;
        }
        &.selected {
            border-color: #dc3545;
            background-color: rgba(220, 53, 69, 0.04);
            box-shadow:
                0 0 0 4px rgba(220, 53, 69, 0.15),
                0 8px 16px rgba(220, 53, 69, 0.1);
            &::after {
                background-color: #dc3545;
            }
        }
    }
}

.image-container {
    overflow: hidden;
    border-radius: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
        transition: transform 0.3s ease;
        max-width: 100%;
    }
}

@keyframes popIn {
    0% {
        transform: scale(0);
        opacity: 0;
    }
    100% {
        transform: scale(1);
        opacity: 1;
    }
}

.pointer-events-none {
    pointer-events: none;
}

.custom-radio-large {
    ::v-deep .custom-control-label {
        &::before {
            width: 1.5rem;
            height: 1.5rem;
            top: 50%;
        }
        &::after {
            width: 1.5rem;
            height: 1.5rem;
            top: 50%;
        }
    }
}
</style>
